import { __rest } from 'tslib';
import React from 'react';
import { useTheme } from '@mui/material/styles';
import { PeekFormControlLabel } from './PeekFormControlLabel.js';
import { PeekRadio } from './PeekRadio.js';

const PeekRadioLabel = (_a) => {
    var { isChecked, label, onClick, disabled } = _a, props = __rest(_a, ["isChecked", "label", "onClick", "disabled"]);
    const theme = useTheme();
    return (React.createElement(PeekFormControlLabel, Object.assign({ control: React.createElement(PeekRadio, { size: "small", sx: {
                p: 0.5,
                mx: 0.3,
            } }), checked: isChecked, onClick: onClick, label: label, disabled: disabled, sx: {
            whiteSpace: "nowrap",
            ".MuiRadio-root": {
                color: `${theme.palette.grey[400]} !important`,
            },
            ".Mui-checked": {
                color: `${theme.palette.success.main} !important`,
            },
        } }, props)));
};

export { PeekRadioLabel, PeekRadioLabel as default };
